export const ifDefined = <T>(value: T | undefined | null, otherwise: T): T =>
  value != null ? value : otherwise;

export const undefinedOrBlank = (value?: string | number | undefined) => {
  return value === undefined || value === '';
};
export const isDefined = <TValue>(
  value: TValue | null | undefined
): value is TValue => value !== null && value !== undefined;
